"use client";

import Script from "next/script";
import { isSentinelValue } from "@/lib/env";

/**
 * HubSpot tracking script loader.
 *
 * Injects the HubSpot embed script which sets the `hubspotutk` cookie on the
 * eTLD+1 of the current domain (e.g. `.radium.cloud`). This cookie is used by
 * the attribution system to associate a contact's first-touch UTM data with
 * their email when they sign up.
 *
 * Must be a Client Component so that `process.env.NEXT_PUBLIC_*` is inlined
 * into the client bundle (which entrypoint.sh replaces at container start),
 * rather than evaluated in a statically pre-rendered Server Component at
 * build time when the env vars still hold sentinel placeholder values.
 *
 * Only renders when NEXT_PUBLIC_HUBSPOT_PORTAL_ID is set and we are not in a
 * test environment, so local/CI Playwright runs never load the real script.
 */
export const HubspotTrackingScript = () => {
  const portalId = process.env.NEXT_PUBLIC_HUBSPOT_PORTAL_ID;

  if (!portalId || isSentinelValue(portalId) || process.env.NODE_ENV === "test") {
    return null;
  }

  return <Script id="hs-script-loader" src={`//js-na2.hs-scripts.com/${portalId}.js`} strategy="afterInteractive" />;
};
